module.exports = __webpack_public_path__ + "ai4jobs-color-logo.png";